import React, { useEffect, useState } from "react";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { FormattedMessage } from "react-intl";
import { ModelWrapper } from "app/pages/company/component/ModelWrapper";
import { Checkbox } from "sr/helpers/ui-components/CheckBox";
import { ChatBox } from "../../ChatBox";
import { Noselected } from "../../Noselected";
import Application from "app/pages/component/types/cleaner/application";
import { getApplication } from "sr/utils/api/cleaner/getApplication";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getUnreadApplication } from "sr/utils/api/cleaner/getUnreadApplication";
import { getUnreadMessageCount } from "sr/utils/api/chat/getUnreadMessageCount";
import { useLocation, useNavigate } from "react-router-dom";
import { useSocket } from "app/pages/component/SocketContext";
import { useDispatch } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { removeUnreadChatCount } from "sr/redux/reducers/cleanerChat";

export const CompanyMessage = () => {
      const [modelShow, setmodelShow] = useState(false)
  const [cleanerId, setCleanerId] = useState<string>()
  const [loader, setLoader] = useState(true)
  const [applications, setApplications] = useState<Application[]>([])
  const [currentJobId, setCurrentId] = useState<string>()
  const [currentData, setCurrentData] = useState<Application>()
  const [unreadApplication, setUnreadApplication] = useState<Application[]>([])
  const [tab, setTab] = useState('Inbox')
  const [localMessageTimes, setLocalMessageTimes] = useState<Record<string, string>>({})
  const [allUnreadApplication, setAllUnreadApplication] = useState([])
  const location = useLocation()
  const navigate = useNavigate()
  const selectedJobId = new URLSearchParams(location.search).get("jobId")
  const socket = useSocket()
  const dispatch = useDispatch<AppDispatch>()
  useEffect(()=> {
      const {user_id}  = getUserDetails()
      setCleanerId(user_id)
  },[])
  const HandleModelByProps = (data)=> {
    setmodelShow(data)
  }

  const getAppJobId = (c: any) => typeof c?.job_id === 'string' ? c?.job_id : (c?.job_id?._id || c?.job_id?.id);

   const fetchAppliedJobs = async ()=> {
    setLoader(true)
    try {
        const queryParams = new URLSearchParams();  
       queryParams.append('cleaner_id', cleanerId.toString());
        const result = await getApplication(queryParams)
        if(result.success===true) {
            setApplications(result?.data)
            setLoader(false)
            }
            else {
            setLoader(false)
            }
    }
    catch(e) {
setLoader(false)
    }
}
const fetchUnreadApplication = async ()=>{
    try{
        const queryParams = new URLSearchParams()
        queryParams.append('cleaner_id', cleanerId)
        const res = await getUnreadApplication(queryParams)
        if(res?.success===true){
            setUnreadApplication(
                currentJobId
                    ? (res?.data || []).filter((item: any) => getAppJobId(item) !== currentJobId)
                    : (res?.data || [])
            )
        }
    }
    catch(e){

    }
}
const clearUnreadForJob = (jobId)=> {
    if(!jobId) return

    setUnreadApplication((prev)=> prev?.filter((item)=> getAppJobId(item) !== jobId))
    setAllUnreadApplication((prev)=> prev?.filter((item)=> getAppJobId(item) !== jobId))
}
useEffect(()=> {
 
    if(cleanerId) {
        fetchAppliedJobs()
        fetchUnreadApplication()
    }
},[cleanerId])
useEffect(()=> {
if (applications?.length) {
    const currentApplication = selectedJobId
      ? applications?.find((item) => getAppJobId(item) === selectedJobId)
      : applications?.[0]

    setCurrentId(getAppJobId(currentApplication))
    setCurrentData(currentApplication)
}
}, [applications, selectedJobId])

useEffect(() => {
  if (currentJobId) {
    clearUnreadForJob(currentJobId)
    dispatch(removeUnreadChatCount({ job_id: currentJobId }))
  }
}, [currentJobId, dispatch])

const fetchUnreadCount = async (cleanerId)=> {
try {
    const queryParams = await new URLSearchParams()
    queryParams.append('cleaner_id', cleanerId)
const res = await getUnreadMessageCount(queryParams)
if(res?.success===true){
setAllUnreadApplication(res?.data)
}
}
catch(e){

}
}
useEffect(()=>{
if(cleanerId){
    fetchUnreadCount(cleanerId)
}
},[cleanerId])

useEffect(() => {
  if (!socket || !cleanerId) return

  const handleSendMessage = ({ messagewithFullData: message }) => {
    const msgJobId = typeof message?.job_id === 'string' ? message?.job_id : (message?.job_id?._id || message?.job_id?.id);
    const msgSenderId = typeof message?.sender_id === 'string' ? message?.sender_id : (message?.sender_id?._id || message?.sender_id?.id);
    
    if (message?.sender_id_type === "company" && msgJobId !== currentJobId) {
      fetchUnreadApplication()
      fetchUnreadCount(cleanerId)
      if (msgSenderId && msgJobId) {
        setLocalMessageTimes(prev => ({...prev, [`${msgSenderId}_${msgJobId}`]: new Date().toISOString()}))
      }
    }
  }

  socket.on("sendmessage", handleSendMessage)

  return () => {
    socket.off("sendmessage", handleSendMessage)
  }
}, [socket, cleanerId, currentJobId])

  return (
   <ContentWithSpinner loader={loader} height="h-screen">
    <div className='lg:container mx-auto lg:max-w-6xl lg:mt-5 mt-5 px-4 lg:px-0'>
    <div className={`flex border-y h-full card-1 bg-white border border-gray-border rounded-xl`}>
        <div className='py-3 w-[33%] border-r-2 border-neutral-300 h-[60vh] overflow-x-auto'>
        <div className='flex items-center mb-3 px-4'>
<div onClick={()=> setTab('Inbox')} className={`rounded-l-lg ${tab==='Inbox' ? 'bg-[#ff39b3] text-white' : 'bg-white text-[#0078ae] border border-neutral-200'} font-bold px-3 py-1  cursor-pointer`}>
<FormattedMessage id="RECRUITER.MESSAGES.TOGGLE.BUTTON.INBOX" defaultMessage="Inbox" />
</div>
<div onClick={()=> setTab('Unread')} className={`rounded-r-lg flex-1 text-center ${tab==='Unread' ? 'bg-[#ff39b3] text-white' : 'bg-white text-[#0078ae] border border-neutral-200'} font-bold px-3 py-1  cursor-pointer`}>
<FormattedMessage id="RECRUITER.MESSAGES.TOGGLE.BUTTON.UNREAD" defaultMessage="Unread" />({unreadApplication?.length})
</div>
    </div>
    <div className='flex items-center space-x-3 relative px-4'>
        <div onClick={()=> setmodelShow(!modelShow)} className='flex-1 flex items-center py-2 px-2 justify-between border rounded-lg border-black hover:shadow-inputshadow hover:border-[#0078ae]'>
        <span><b><FormattedMessage id="RECRUITER.MESSAGES.FILTER.TITLE" defaultMessage="Filter by job" />:</b> <FormattedMessage id="RECRUITER.MESSAGES.FILTER.COMMON.TYPE" defaultMessage="All Jobs" /></span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
</svg></div>
<svg onClick={fetchAppliedJobs} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer text-[#0078ae]">
  <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
</svg>

    
    {modelShow && 
    <ModelWrapper HandleModelByProps={HandleModelByProps} topPosition='top-5' border='border border-black'>
    <div className=' w-full px-4 py-4'>
<Checkbox id='Web' label='Web Developer - Lucknow, Uttar Pradesh' name='Web' value='Web Developer - Lucknow, Uttar Pradesh'/>
    </div>
    </ModelWrapper>
}
        </div>
        <hr className='border-2 border-neutral-200 mt-4'></hr>
        {(() => {
              const getLastMessageTime = (data) => {
                  const key = `${data?.job_id?.company_id?._id || data?.job_id?.company_id}_${data?.job_id?._id}`;
                  if (localMessageTimes[key]) return localMessageTimes[key];
                  
                  const chatInfo = allUnreadApplication?.find((item)=> item?.job_id?._id === data?.job_id?._id);
                  return chatInfo?.lastMessageTime || data?.createdAt;
              };
              
              const listToRender = tab === 'Inbox' ? applications : unreadApplication;
              const sortedList = [...listToRender].sort((a, b) => {
                  const timeA = new Date(getLastMessageTime(a)).getTime();
                  const timeB = new Date(getLastMessageTime(b)).getTime();
                  return timeB - timeA;
              });

              return sortedList.map((data, index)=> (
        <div key={data?.id} onClick={()=> {
            const jobId = getAppJobId(data);
            setCurrentId(jobId); 
            setCurrentData(data); 
            navigate(`/cleaner/message?jobId=${jobId}`, { replace: true })
        }} className={`${currentJobId === getAppJobId(data) ? 'bg-[#ecf5ff]':'bg-white hover:bg-[#faf9f8]'}  p-4 border-b border-neutral-200  relative cursor-pointer`}>
<div className='flex items-center justify-between space-x-2'>
<span className='text-gray-600 font-sm'>
Applied to {data?.job_id?.job_title}
</span>
<div className="">
<span className='text-gray-600 font-sm'>
{DateFormat(getLastMessageTime(data))}
</span>
{allUnreadApplication?.find((item)=> getAppJobId(item) === getAppJobId(data))?.unreadCount >0 &&
<div className="rounded-full bg-[#ff39b3]  font-bold absolute top-12 right-6 text-white w-5 h-5 flex justify-center items-center">
    <span className="text-[0.8rem] ">{allUnreadApplication?.find((item)=> getAppJobId(item) === getAppJobId(data))?.unreadCount}</span></div>
}
</div>
</div>
<p className=''>{data?.job_id?.company_id?.company_name}</p>
        </div> ))
        })()}
        </div>
<div className='flex-1 w-[65%] h-[80vh] '>
    {currentJobId ? <ChatBox key={currentJobId} data={currentData} fetchUnreadCount={fetchUnreadCount} fetchUnreadApplication={fetchUnreadApplication} clearUnreadForJob={clearUnreadForJob} updateLastMessageTime={(companyId, jobId, time) => setLocalMessageTimes(prev => ({...prev, [`${companyId}_${jobId}`]: time}))}/>:
    (
        (<Noselected />)
    )
    }
</div>
    </div></div>
    </ContentWithSpinner>
);
};
